/**
 * Backgammon engine constants — a verbatim port of the relevant parts of
 * Client/Assets/NetworkModels/GameEnums.cs (namespace GameStars.Models.NetworkModels.Enums).
 *
 * The engine in this folder is a 1:1 port of the SHARED C# engine that runs on both the Unity client
 * and the server (Client/Assets/Code/Games/BackgammonLogic.cs +
 * Client/Assets/Code/CommonClasses/BackgammonCommon.cs). It MUST produce identical move suggestions
 * and validation, otherwise the server rejects moves this client believes are legal. Keep these
 * values and the logic in lock-step with the C# source.
 */

/** Bead/checker owner. NotSet is the "empty point" sentinel (BeadRow.Color returns it when Count==0). */
export enum BeadColor {
  NotSet = 0,
  White = 1,
  Black = 2,
}

/** Table phase, as computed by GetTableState(). Only six of these are produced by the engine. */
export enum BoardState {
  StartGame = 0,
  WaitForDice = 1,
  WhiteAllowMove = 2,
  BlackAllowMove = 3,
  WhiteWaiting = 4,
  BlackWaiting = 5,
  WhiteAllowToMoveOut = 6,
  BlackAllowToMoveOut = 7,
  Finish = 8,
}

// Board row index system (NetworkConstants.BACKGAMMON_*). Game rows are 0..23; the bar (waiting) and
// bearing-off (out) areas use the sentinel indices below.
export const BACKGAMMON_START_ROW = 0;
export const BACKGAMMON_ROWS_COUNT = 24;
export const BACKGAMMON_WAIT_ROW_WHITE = -30;
export const BACKGAMMON_WAIT_ROW_BLACK = -31;
export const BACKGAMMON_OUT_ROW_WHITE = 30;
export const BACKGAMMON_OUT_ROW_BLACK = 31;
